/**
 * @file   error-msg.js 网络状态码
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2020-12-21
 */

export default {
};
